import { apiClient } from '@/lib/api-client';

export interface ComposeInput {
  channel: 'Email' | 'WhatsApp';
  to: string[];
  subject?: string;
  body: string;
  senderProfileId?: string | null;
}

export const composeApi = {
  send(input: ComposeInput): Promise<{ queued: string[] }> {
    return apiClient.post('/admin/compose', input);
  },
};
